import { Injectable, inject } from '@angular/core'
import { BvAlertService } from '@ziptility/bv-alert'
import { ExportAPIService, FeatureAPIService } from '@modules/bv-api'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { of } from 'rxjs'
import { catchError, switchMap, map } from 'rxjs/operators'
import { MapboxMapCoordinator, NavigationService } from '../../services'
import { downloadFile } from '../../services/download.helper'
import { MapActions } from '../actions'
import * as SearchActions from './actions'
import { EditorStore } from '@ziptility/editor'

@Injectable()
export class SearchEffects {
  readonly navigationService = inject(NavigationService)
  readonly store = inject(Store)
  readonly actions$ = inject(Actions)
  readonly exportAPIService = inject(ExportAPIService)
  readonly featureAPIService = inject(FeatureAPIService)
  readonly mapCoordinator = inject(MapboxMapCoordinator)
  readonly alertService = inject(BvAlertService)
  readonly editorStore = inject(EditorStore)

  AdvancedSearchStartRequest$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SearchActions.advancedSearch),
      switchMap(({ layerIds, filters }) => {
        return this.featureAPIService.advancedSearch({ layerIds: layerIds, filters }).pipe(catchError(() => of([])))
      }),
      switchMap((features) => {
        if (!features.length) {
          this.alertService.error(`No results found. Please try widening your search criteria.`)
        }

        this.mapCoordinator.presentFeatures(features)
        return [
          MapActions.selectFeatures({ features: features.map((f) => ({ id: f.id, layerId: f.layerId })) }),
          SearchActions.advancedSearchSuccess({ features }),
        ]
      }),
    ),
  )

  AdvancedSearchExportStartRequest$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SearchActions.exportAdvancedSearchResults),
        switchMap((payload) => {
          const { mapId, layerIds, filters } = payload
          return this.exportAPIService
            .advancedLayerExport({ mapId, layerIds, filters })
            .pipe(map((res) => downloadFile(res)))
        }),
      ),
    { dispatch: false },
  )
}
